<template>
  <div>
    <a href="https://analytics.google.com/analytics/web/?authuser=0&hl=ja#/p421483950/reports/dashboard?r=firebase-overview" target="_blank">Google Analyticsで表示</a>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="summaries"
      item-key="id"
    >
    </v-data-table>
  </div>
</template>

<script>
  import mixin from '@/util/mixin'

  export default {
    mixins: [mixin],
    data () {
      return {
        dialog: false,
        reason: '11',
        db: null,
        selected: [],
        headers: [
          {
            text: 'ID',
            align: 'start',
            sortable: false,
            value: 'id',
          },
          { text: '作成日時', value: 'createdAt' },
          { text: '予想', value: 'prediction' },
          { text: '選択肢', value: 'choice' },
          { text: 'コメント', value: 'comments' },
          { text: '返信', value: 'reply' },
          { text: '回答', value: 'answer' },
          { text: '投票', value: 'report' },
          { text: 'ランク', value: 'rank' },
          { text: 'お知らせ', value: 'notification' },
          { text: 'ユーザー', value: 'users' },
          { text: 'レシート', value: 'receipts' },
        ],
        summaries: []
      }
    },
    methods: {
      getSummaries () {
        this.$fb.getDocs(this.$fb.query(this.$fb.collection(this.$fb.firestore, 'summary')
          .withConverter(this.summaryConverter),
          this.$fb.orderBy('created_at', 'desc'),
          this.$fb.limit(1000)))
          .then(summarySnap => {
            this.summaries = []
            summarySnap.forEach(summaryDoc => {
              this.summaries.push(summaryDoc.data())
            })
          }).catch(error => {
            console.error(error)
            this.summaries = []
          })
      },
    },
    created () {
      this.getSummaries()
    }
  }
</script>